import './NotificationSwitch.less';

import clsx from 'clsx';
import React from 'react';

import Switch, { switcher_110_5 } from '@/common/components/Switch';

export default function NotificationSwitch({ className, label, type, value, onChange }) {
    function onLeftClick(e) {
        onChange(type, false);
        e.preventDefault();
    }
    function onRightClick(e) {
        onChange(type, true);
        e.preventDefault();
    }
    return (
        <div className={clsx('notification-switch col-switch', className)}>
            <div className="col-switch-left">
                <p>{label}</p>
            </div>
            <div className="col-switch-right">
                <Switch
                    switched={value}
                    onLeftClick={onLeftClick}
                    onRightClick={onRightClick}
                    switcherAnchorStyler={switcher_110_5}
                    disabled={false}
                />
            </div>
        </div>
    );
}
